import React from "react";

export default function Classy() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 37 36"
      fill="none"
    >
      <path
        stroke="#000"
        strokeWidth={5}
        d="M3.318 2.494H23.87c5.523 0 10 4.478 10 10v20.553H13.318c-5.523 0-10-4.477-10-10V2.494Z"
      />
      <path fill="#DDE0E4" d="M12.373 11.549H24.82v12.447H12.373z" />
    </svg>
  );
}
